export default {
  name: 'message',
  path: 'message',
  component: () => import(/* webpackChunkName: "message" */ './list.vue')
}
